import { render, staticRenderFns } from "./insBaseField.vue?vue&type=template&id=0f5d6654&"
import script from "./insBaseField.vue?vue&type=script&lang=js&"
export * from "./insBaseField.vue?vue&type=script&lang=js&"
import style0 from "./insBaseField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports